import { render, staticRenderFns } from "./AutomationStatisticsGeneralCard.vue?vue&type=template&id=6a67221d&scoped=true&"
import script from "./AutomationStatisticsGeneralCard.vue?vue&type=script&lang=js&"
export * from "./AutomationStatisticsGeneralCard.vue?vue&type=script&lang=js&"
import style0 from "./AutomationStatisticsGeneralCard.vue?vue&type=style&index=0&id=6a67221d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67221d",
  null
  
)

export default component.exports